module.exports = __webpack_public_path__ + "static/media/PlayCircleIcon.07ba905d.svg";